import { Functions, httpsCallable } from 'firebase/functions';

export class TriggerFunctionInteractor {
  constructor(private readonly functions: Functions) {}

  public async execute(name: string): Promise<void> {
    const fn = httpsCallable<void, void>(this.functions, name);
    await fn();
  }
}
